module.exports = __webpack_public_path__ + "static/dev-ec165fca1a4a60f02f8ad8ec04cc1153.svg";